/**
 * Cross-platform detection seam.
 *
 * OmniMedia currently ships only the web app; the native shells (mobile,
 * desktop/Electron, Android TV) will be rebuilt from scratch. These helpers are
 * the single re-integration point for those shells: on the plain web build they
 * all resolve to the web/offline-incapable branch, and a future shell only needs
 * to expose `window.omnimediaDesktop` (see `omnimedia-desktop.d.ts`) to light the
 * desktop paths back up. Keep this surface small and side-effect free.
 */

/** True when running inside the OmniMedia Electron desktop shell (false on web). */
export function isDesktopShell(): boolean {
  return typeof window.omnimediaDesktop !== "undefined";
}

/**
 * True on phone/tablet browsers (not the desktop shell). The web app works on
 * mobile browsers, so this no longer gates any surface — it's a responsive/UX
 * detection helper and a seam for the future native shells.
 */
export function isMobileWebBrowser(): boolean {
  if (typeof window === "undefined") return false;
  if (isDesktopShell()) return false;
  return (
    window.matchMedia("(max-width: 767px)").matches ||
    /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
  );
}

/**
 * Full offline-capable player (durable sync mirror, media cache, telemetry
 * queue). Desktop shell only — mobile has its own offline stack.
 */
export function isOfflineCapablePlayer(): boolean {
  return isDesktopShell();
}
